import slugify from 'slugify';

export const waitFor = (ms: number) => new Promise((resolve) => setTimeout(resolve, ms));

export const identity = <T>(data: T) => data;

export const withSlug = (base: string, name: string = ':id') =>
  `${base}/${slugify(name, { lower: true })}`;

export const withParam = (base: string, param: string = ':param') => `${base}/${param}`;


// Tabela de demandas - Função para indicar data de entrega/prazo atrasado

const STATUS_ENCERRADO = new Set([
  'FINALIZADA',
  'SOLUCIONADA',
  'EXCLUIDA',
  'RECUSADA',
  'ERRADA',
  'REPROVADA',
  'DEVOLVIDA',
] as const);

const parseDateLocal = (value?: string | null): Date | null => {
  if (!value) return null;

  //evitar erro de fuso em datas YYYY-MM-DD
  if (/^\d{4}-\d{2}-\d{2}$/.test(value)) {
    const [y, m, d] = value.split('-').map(Number);
    return new Date(y, m - 1, d, 23, 59, 59, 999);
  }
  const dt = new Date(value);
  if (Number.isNaN(dt.getTime())) return null;

  dt.setHours(23, 59, 59, 999);
  return dt;
};

const isCampoAtrasado = (
  demanda: any,
  campo: 'sugestao_entrega' | 'previsao_entrega'
): boolean => {
  const prazo = parseDateLocal(demanda?.[campo]);
  if (!prazo) return false;

  if (demanda?.status && STATUS_ENCERRADO.has(demanda.status as any)) return false;

  return prazo.getTime() < Date.now();
};

export const isPrazoAtrasado = (demanda: any): boolean =>
  isCampoAtrasado(demanda, 'sugestao_entrega');

export const isPrevisaoAtrasada = (demanda: any): boolean =>
  isCampoAtrasado(demanda, 'previsao_entrega');